export default "__VITE_ASSET__CgJjeCYh__"